<template>
    <section id="post">
        <div class="holder" v-if="holder"></div>

        <div v-else class="container">
            <div class="breadcrumb bread-post">
                <router-link class="breadcrumb__link" to="/">Home</router-link>
                <router-link class="breadcrumb__link" to="/blog">Blog</router-link>
                <p class="breadcrumb__link">{{post.title}}</p>
            </div>

            <div class="post-container">
                <div class="post">
                    <div class="post-info">
                        <span class="post-info__flag"
                              :style="{backgroundColor: post.categoria.color}">{{post.categoria.name}}</span>
                        <h2 class="post-info__title">{{post.title}}</h2>
                        <div class="post-info__details">
                            <p>Escrito por: <span class="post-info__autor">Fibrillare</span></p>
                            <p>Data: <span class="post-info__date">{{post.created_at}}</span></p>
                        </div>
                    </div>
                    <div class="post-content">
                        <div>
                            <lazy-image class="post-content__img" :image="post.file" />
                        </div>
                        <vue-markdown :source="post.text" class="post-content__desc"></vue-markdown>
                        <vue-markdown :source="post.body" class="post-content__text"></vue-markdown>
                    </div>
                    <div class="post-socials">
                        <div class="socials">
                            <span class="socials__title">Compartilhe</span>
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/FibrillareMoveis/" target="_blank"> <img
                                            src="@/assets/icons/face-black.svg" alt="">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank"> <img src="@/assets/icons/twitter-black.svg" alt="">
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/fibrillare/" target="_blank"> <img
                                            src="@/assets/icons/insta-black.svg" alt="">
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="featured">
                    <h2 class="featured__title">Conteúdos mais lidos</h2>
                    <Sidebar/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Sidebar from "../components/Blog/Sidebar/Sidebar";
    import VueMarkdown from 'vue-markdown';
    import LazyImage from "../components/Shared/LazyImage";

    export default {
        name: "Post",
        props: ['currentPost', 'id'],
        data() {
            return {
                holder: true,
                post: {},
            }
        },
        methods: {
            fetchPost() {
                axios.get(`/blog/${this.id}}`)
                    .then(r => {
                        this.post = r.data;
                        this.holder = false;
                    })
            },
        },
        watch: {
            $route: {
                handler: function () {
                    this.fetchPost();
                },
                immediate: true
            },
        },
        mounted() {
            this.fetchPost();
            document.title = 'Fibrillare - Post';
            window.scrollTo({
                top: 0,
                behavior: 'auto'
            })
        },
        components: {
            Sidebar,
            VueMarkdown,
            LazyImage
        },
    }
</script>

<style lang="scss" scoped>
    .bread-post {
        max-width: 100%;

        p {
            &:hover {
                text-decoration: none;
            }
        }
    }

    #post {
        margin-top: 83px;
    }

    .post-container {
        display: flex;
        justify-content: space-between;
    }

    .post {
        max-width: 770px;
    }

    .post-info {
        &__flag {
            display: inline-block;
            font-family: "Open Sans";
            font-size: 0.875rem;
            background: #000;
            border-radius: 4px;
            color: #fff;
            padding: 5px 1.875rem;
            margin-bottom: 20px;
        }

        &__title {
            font-family: "Open Sans";
            font-size: 2rem;
            font-weight: 600;
            margin-bottom: 10px;
        }

        &__autor {
            display: inline-block;
            margin-left: 5px;
            font-family: "Open Sans";
            font-size: 0.75rem;
            color: #2b2b2b;
        }

        &__date {
            display: inline-block;
            margin-left: 5px;
            font-family: "Open Sans";
            font-size: 0.75rem;
            color: #2b2b2b;
        }
    }

    .post-info__details {
        display: flex;
        margin-bottom: 20px;

        p {
            font-family: "Open Sans";
            color: #666666;
            font-size: 0.8rem;
        }

        p:first-child {
            margin-right: 25px;
            position: relative;

            &::after {
                display: block;
                content: '';
                width: 1px;
                height: 10px;
                background: #666;
                position: absolute;
                right: -25px;
                top: 5px;
            }
        }

        p:last-child {
            margin-left: 30px;
        }
    }

    .post-content {

        &__text {
            font-family: 'Open Sans';
            color: #2b2b2b;
            line-height: 26px;
        }

        &__img {
            object-fit: cover;
            margin-bottom: 30px;
            width: 770px;
            height: 380px;
            overflow: hidden;
        }

        &__desc {
            font-family: "Open Sans";
            color: #666666;
            margin-bottom: 40px;
            margin-top: 10px;
        }
    }

    .post-socials {
        margin-top: 60px;
        display: flex;
        width: 100%;
        justify-content: center;
        position: relative;

        .socials {
            text-align: center;
            font-family: "Open Sans";
            color: #2b2b2b;
            font-size: 0.875rem;
            background: #fff;

            &::after {
                display: block;
                content: '';
                background: #2b2b2b;
                width: 100%;
                position: absolute;
                height: 2px;
                right: 0;
                top: 65%;
                transform: translate3d(0, -65%, 0);
                z-index: 0;
            }
        }

        ul {
            display: flex;
            margin: 0 20px;
            background: #fff;
            align-items: center;
            z-index: 1;
            position: relative;
            padding: 0 20px;

            li {
                margin: 0px;

                a {
                    display: block;
                    padding: 10px;
                }
            }
        }
    }

    .featured {
        min-width: 270px;
    }

    .featured__title {
        margin-top: 30px;
        width: 100%;
        font-family: "Open Sans";
        font-size: 1.375rem;
        color: #0a0a0a;
        border-bottom: 2px solid #0a0a0a;
        line-height: 3;
    }

    @media only screen and(max-width: 1200px) {
        .post {
            max-width: 670px;
        }
    }

    @media only screen and(max-width: 768px) {
        .post-container {
            flex-direction: column;
            justify-content: center;
        }

        .post {
            max-width: 100%;
        }

        .blog-news-carousel {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
        }

        .breadcrumb {
            padding-top: 40px;
        }
    }
</style>